window.TOPBAR_SHADER_INIT=function(){if(window.TOPBAR_SHADER_has_INIT==!0){return}
window.TOPBAR_SHADER_has_INIT=!0;function hexToSRGBVector(hex){const result=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);return result?new THREE.Vector3(parseInt(result[1],16)/255,parseInt(result[2],16)/255,parseInt(result[3],16)/255):new THREE.Vector3(0,0,0)}
window.TOPBAR_CONFIG={colorHighlight:hexToSRGBVector(HIGHLIGHT_COLOR[0]),colorAnti:hexToSRGBVector(HIGHLIGHT_COLOR[2]),barberpoleSpeed:2.0,distortionStrength:2.0};const vertexShader=`
        varying vec2 vUv;
        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `;const trailShader=`
        uniform vec2 uResolution;
        uniform vec2 uMouse;
        uniform float uMouseInfluence;
        uniform sampler2D uPreviousTrail;
        uniform float uDecay; // How fast the trail fades

        varying vec2 vUv;

        void main() {
            vec2 fragCoord = vUv * uResolution;

            // Get previous trail value and decay it (slower decay for visible trail)
            float previousInfluence = texture2D(uPreviousTrail, vUv).r * uDecay;

            // Add new influence from current mouse position
            float newInfluence = 0.0;
            if (uMouseInfluence > 0.0) {
                float dist = length(fragCoord - uMouse);
                float radius = 10.0; // Reduced brush size to match original radius
                newInfluence = smoothstep(radius, 0.0, dist) * uMouseInfluence;
            }

            // Combine (take max to prevent darkening where mouse passes multiple times)
            float finalInfluence = max(previousInfluence, newInfluence);

            gl_FragColor = vec4(finalInfluence, 0.0, 0.0, 1.0);
        }
    `;const fragmentShader=`
        uniform float uTime;
        uniform vec2 uResolution;
        uniform float uVH; // Viewport Height in Pixels
        uniform vec3 uColorHighlight;
        uniform vec3 uColorAnti;
        uniform vec2 uMouse; // Mouse position in pixels
        uniform float uMouseInfluence; // 0.0 to 1.0, fades in/out
        uniform sampler2D uTrailTexture; // Trail influence texture

        varying vec2 vUv;

        // Pseudo-random function
        float hash(float n) { return fract(sin(n) * 43758.5453123); }
        vec2 hash2(float n) { return fract(sin(vec2(n, n + 1.0)) * vec2(43758.5453123, 22578.1459123)); }

        // Function to generate a single "blob particle" influence
        // Returns a value that contributes to the "goo" field
        // rate: particles per second
        // index: particle index in the loop
        float getParticleInfluence(vec2 uv, vec2 origin, float index, float time, float rate, float spread, float baseRadius) {
            
            // Calculate cycle offset so particles emit in a steady stream, not all at once
            float offset = index * (1.0 / rate);
            float t = time - offset;
            
            // Lifespan logic
            // We use mod to loop the lifecycle of this specific particle index
            // Let's say lifespan is 1.5 seconds
            float lifespan = 1.5;
            float age = mod(t, lifespan); // 0.0 to lifespan
            float cycle = age / lifespan; // 0.0 to 1.0
            
            // Randomize direction based on index (constant for this specific particle instance)
            vec2 dir = normalize(hash2(index * 12.34) - 0.5);
            
            // Position moves away from origin
            vec2 pos = origin + dir * (spread * cycle);
            
            // SIZE LOGIC:
            // 1. Grow in (first 15% of life ~ 200ms)
            // 2. Shrink out (after 50% or linear decay)
            float grow = smoothstep(0.0, 0.15, cycle);
            float decay = 1.0 - smoothstep(0.4, 1.0, cycle);
            
            // Combine
            float size = baseRadius * grow * decay;
            
            // Calculate distance
            float dist = length(uv - pos);
            
            // Metaball influence
            // Optimization: smoothstep influence radius
            float radiusOfInfluence = size * 2.5; 
            
            // If cycle is very start or very end, influence is 0
            if (size <= 0.001) return 0.0;

            return smoothstep(radiusOfInfluence, 0.0, dist); 
        }

        void main() {
            vec2 fragCoord = vUv * uResolution;
            
            // --- 1. CALCULATE GOO POTENTIAL ---
            // We do this first so we can use it to warp the background
            
            float potential = 0.0;
            
            // Configuration for Emitters
            // To support 12/sec with 1.5s lifespan, we need ceil(12 * 1.5) = 18 particles in loop
            float sideRate = 8.0; 
            float centerRate = 30.0; // Double rate for center

            // -- Emitter 1: Left Circle --
            vec2 posLeft = vec2(2.5 * uVH, 0.5 * uResolution.y);
            // Static Core
            potential += smoothstep(2.5 * uVH, 0.0, length(fragCoord - posLeft)); 
            // Particles
            for(float i = 0.0; i < 20.0; i++) {
                potential += getParticleInfluence(fragCoord, posLeft, i, uTime, sideRate, 5.0 * uVH, 1.5 * uVH);
            }

            // -- Emitter 2: Right Circle --
            vec2 posRight = vec2(uResolution.x - (2.5 * uVH), 0.5 * uResolution.y);
            // Static Core
            potential += smoothstep(2.5 * uVH, 0.0, length(fragCoord - posRight));
            // Particles
            for(float i = 100.0; i < 120.0; i++) { // Offset index to randomize seeds
                potential += getParticleInfluence(fragCoord, posRight, i, uTime, sideRate, 5.0 * uVH, 1.5 * uVH);
            }

            // -- Emitter 3: Center Oval --
            vec2 posCenter = vec2(0.5 * uResolution.x, 0.5 * uResolution.y);
            
            // Oval Space Math
            vec2 centerDist = fragCoord - posCenter;
            vec2 ovalSpace = centerDist;
            // Twice as wide as before (was 0.4, now 0.2)
            ovalSpace.x *= 0.2; 
            
            // Static Core (Oval)
            potential += smoothstep(5.0 * uVH, 0.0, length(ovalSpace));
            
            // Particles
            // Need ~40 particles for the higher rate
            for(float i = 200.0; i < 240.0; i++) {
                // Spread origin horizontally for oval emitter
                float xOffset = (hash(i) - 0.5) * 16.0 * uVH; // Wider spread for wider oval
                vec2 pOrigin = posCenter + vec2(xOffset, 0.0);
                
                potential += getParticleInfluence(fragCoord, pOrigin, i, uTime, centerRate, 30.0 * uVH, 2.8 * uVH);
            }

            // --- 2. LIQUID DISTORTION ---
            // Use potential to warp the coordinate space for the barberpole
            // We add the potential to the coordinate to shift the stripes
            float warp = potential * uVH * 3.0; // 3.0 is strength factor

            // Add cursor-based liquid warping using trail texture (memory foam effect)
            float cursorWarp = 0.0;
            if (uMouseInfluence > 0.0) {
                // Sample the trail texture to get accumulated influence
                float trailInfluence = texture2D(uTrailTexture, vUv).r * 3.0;

                // Add directional warp based on trail (push effect)
                // Calculate direction from current position to mouse
                vec2 toMouse = uMouse - fragCoord;
                float distToMouse = length(toMouse);
                vec2 pushDir = distToMouse > 0.1 ? normalize(toMouse) : vec2(1.0, 0.0);

                // Warp based on trail influence
                cursorWarp = trailInfluence * uVH * 5.0 * pushDir.x; // Horizontal warp component
            }

            warp += cursorWarp;

            // --- 3. BARBERPOLE BACKGROUND ---
            float stripeSize = 2.75 * uVH; 
            
            // Add 'warp' to the X coordinate effectively
            float progression = (fragCoord.x - warp) + fragCoord.y + (uTime * 50.0 * 6.0);
            
            float stripe = mod(progression, stripeSize * 2.0);
            vec3 bgColor = (stripe < stripeSize) ? uColorHighlight : uColorAnti;

            // --- 4. COMPOSITION ---
            
            // Hard threshold for flat look (no soft edges/rims)
            // Using a tight smoothstep for anti-aliasing but sharp appearance
            float gooMask = smoothstep(0.48, 0.52, potential);
            
            vec3 finalColor = mix(bgColor, uColorHighlight, gooMask);

            gl_FragColor = vec4(finalColor, 1.0);
        }
    `;const container=document.getElementById('topbar-canvas-container');const scene=new THREE.Scene();const camera=new THREE.OrthographicCamera(-1,1,1,-1,0,1);const renderer=new THREE.WebGLRenderer({alpha:!1,antialias:!1,powerPreference:'high-performance',desynchronized:!0,stencil:!1,preserveDrawingBuffer:!1});renderer.setPixelRatio(window.devicePixelRatio);renderer.outputColorSpace=THREE.SRGBColorSpace;container.appendChild(renderer.domElement);const width=container.offsetWidth;const height=container.offsetHeight;renderer.setSize(width,height);const trailRenderTarget1=new THREE.WebGLRenderTarget(width/2,height/2,{minFilter:THREE.LinearFilter,magFilter:THREE.LinearFilter,format:THREE.RGBAFormat,type:THREE.FloatType});const trailRenderTarget2=trailRenderTarget1.clone();const trailScene=new THREE.Scene();const trailGeometry=new THREE.PlaneGeometry(2,2);const trailMaterial=new THREE.ShaderMaterial({vertexShader,fragmentShader:trailShader,uniforms:{uResolution:{value:new THREE.Vector2(width/2,height/2)},uMouse:{value:new THREE.Vector2(width/2,height/2)},uMouseInfluence:{value:0.0},uPreviousTrail:{value:null},uDecay:{value:0.985}}});const trailMesh=new THREE.Mesh(trailGeometry,trailMaterial);trailScene.add(trailMesh);let currentTrailTarget=trailRenderTarget1;let previousTrailTarget=trailRenderTarget2;const uniforms={uTime:{value:0},uResolution:{value:new THREE.Vector2(width,height)},uVH:{value:height/15.0},uColorHighlight:{value:TOPBAR_CONFIG.colorHighlight},uColorAnti:{value:TOPBAR_CONFIG.colorAnti},uMouse:{value:new THREE.Vector2(width/2,height/2)},uMouseInfluence:{value:0.0},uTrailTexture:{value:currentTrailTarget.texture}};uniforms.uVH.value=window.innerHeight/100.0;const geometry=new THREE.PlaneGeometry(2,2);const material=new THREE.ShaderMaterial({vertexShader,fragmentShader,uniforms});const mesh=new THREE.Mesh(geometry,material);scene.add(mesh);window.topbarResize=function(){const w=container.offsetWidth;const h=container.offsetHeight;renderer.setSize(w,h);uniforms.uResolution.value.set(w,h);uniforms.uVH.value=window.innerHeight/100.0;trailRenderTarget1.setSize(w/2,h/2);trailRenderTarget2.setSize(w/2,h/2);trailMaterial.uniforms.uResolution.value.set(w/2,h/2)}
topbarResize();const clock=new THREE.Clock();var renderedOnceEver=!1;var isPaused=!1;var animationStarted=!1;const enableMouseTracking=!window.isMobile()&&!window.isLowEndDevice();function isFullscreenActive(){try{return window.clayInstance?.fullscreenState?.active===!0}catch(e){return!1}}
function animate(){if(!animationStarted)return;requestAnimationFrame(animate);if(document.hidden)return;if(isFullscreenActive()){if(!isPaused){clock.stop();isPaused=!0}}else{if(isPaused){clock.start();isPaused=!1}
uniforms.uTime.value=clock.getElapsedTime()/8;if(enableMouseTracking){trailMaterial.uniforms.uPreviousTrail.value=previousTrailTarget.texture;const scaledMouseX=uniforms.uMouse.value.x/2;const scaledMouseY=uniforms.uMouse.value.y/2;trailMaterial.uniforms.uMouse.value.set(scaledMouseX,scaledMouseY);trailMaterial.uniforms.uMouseInfluence.value=uniforms.uMouseInfluence.value;renderer.setRenderTarget(currentTrailTarget);renderer.render(trailScene,camera);renderer.setRenderTarget(null);const temp=currentTrailTarget;currentTrailTarget=previousTrailTarget;previousTrailTarget=temp;uniforms.uTrailTexture.value=currentTrailTarget.texture}}
renderer.render(scene,camera)}

// PERFORMANCE OPTIMIZATION: Render static frame immediately, defer animation loop
// This removes ~2-3 seconds of JS execution from LCP/TBT measurements

// 1. Render one static frame immediately for instant visual
uniforms.uTime.value = 0;
renderer.render(scene, camera);
renderedOnceEver = true;
document.getElementById('topbar-canvas-container').classList.remove('topbar-canvas-uninit');

// 2. Defer animation loop until after page is interactive
function startAnimationLoop() {
    if (animationStarted) return; // Prevent double-start
    animationStarted = true;
    clock.start();
    animate();
}

function deferAnimation() {
    if ('requestIdleCallback' in window) {
        requestIdleCallback(startAnimationLoop, { timeout: 100 });
    } else {
        setTimeout(startAnimationLoop, 100);
    }
}

if (document.readyState === 'complete') {
    deferAnimation();
} else {
    window.addEventListener('load', deferAnimation, { once: true });
}

function setupFullscreenListener(){const fullscreenButton=document.getElementById('clay-fullscreen');if(fullscreenButton){fullscreenButton.addEventListener('click',()=>{setTimeout(()=>{if(isFullscreenActive()){clock.stop();isPaused=!0}else{clock.start();isPaused=!1}},50)})}}
setupFullscreenListener();const observer=new MutationObserver(()=>{const fullscreenButton=document.getElementById('clay-fullscreen');if(fullscreenButton){setupFullscreenListener();observer.disconnect()}});observer.observe(document.body,{childList:!0,subtree:!0});let mouseInfluenceTarget=0.0;if(enableMouseTracking){window.addEventListener('mousemove',(e)=>{const rect=container.getBoundingClientRect();const mouseY=e.clientY-rect.top;if(mouseY>=0&&mouseY<=container.offsetHeight){const mouseX=e.clientX-rect.left;uniforms.uMouse.value.set(mouseX,container.offsetHeight-mouseY);mouseInfluenceTarget=0.3}else{mouseInfluenceTarget=0.0}});function updateMouseInfluence(){const speed=0.05;uniforms.uMouseInfluence.value+=(mouseInfluenceTarget-uniforms.uMouseInfluence.value)*speed;requestAnimationFrame(updateMouseInfluence)}
updateMouseInfluence()}
return[material,scene]}